module.exports = __webpack_public_path__ + "img/1837.97fbc9bd.gif";